import React, { useRef, useState } from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    FORM,
    INTERNATIONAL,
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import ProgramLangs from "./_langs";
import {
    FL_ACTIVITY,
    FL_IMAGE,
    FL_ORDER,
    FL_STATUS,
} from "../../../components/i18n/formLabels";
import {
    PH_IMAGE,
} from "../../../components/i18n/placeHolders";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/atv/programActions";
import {connect} from "react-redux";

const ProgramForm = (props) => {
    const { editMode, disableInputs, domainObject } = props.formProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id;
    const translatedLangs = domainObject?.translatedLangs

    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [activityId, setActivityId] = useState( editMode ? domainObject?.activity?.id : null);

    const [resetValues, setResetValues] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
    });

    const handleSwitchs = (field) => {
        const tmpObject = JSON.parse(JSON.stringify(domainObject)) || {}
        tmpObject[field] = tmpObject[field] ? !tmpObject[field] : true
        props.setItem(tmpObject)
    }

    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            fileName: domainObject?.fileName,
            status: domainObject?.status,
            showOrder: domainObject?.showOrder
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                id: domainObject?.id,
                status: domainObject?.status ?? false,
            }
        };

        if (langs && langs.length){
            dataRequest.item.langs = langs;
        }

        if (editMode) {
            let id = domainObject.id;
            props.update(id, dataRequest)
        } else {
            props.save(dataRequest)
        }

        returnToList()
    };

    const returnToList = () => {
        reset();
        props.setItem(null);
        props.setForm(false, false, false);
        props.setViewMode("LIST");
    }

    return (<>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_ORDER}</Label>
                                <Input type="number" name="showOrder"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_IMAGE}</Label>
                                <Input type="text" name="fileName"
                                       placeholder={PH_IMAGE}
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        {/*<Col md="3">*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label>{ FL_ACTIVITY }</Label>*/}
                        {/*        <br/>*/}
                        {/*        <SelectGeneric*/}
                        {/*            isDisabled={disableInputs}*/}
                        {/*            initialValue={activityId}*/}
                        {/*            setExternalValue={setActivityId}*/}
                        {/*            provider={activityProvider}*/}
                        {/*            resetValue={resetValues}*/}
                        {/*        />*/}
                        {/*    </FormGroup>*/}
                        {/*</Col>*/}
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={domainObject?.status || false}
                                        onChange={() => handleSwitchs('status')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{INTERNATIONAL}
                    </CardTitle>
                    <CardBody>
                        <ProgramLangs
                            langs={langs}
                            setLangs={setlangs}
                            translatableLangs={translatedLangs}
                        />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={returnToList}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ProgramForm)
